import { render, staticRenderFns } from "./highlightGrid.vue?vue&type=template&id=071d0bc7&scoped=true&"
import script from "./highlightGrid.vue?vue&type=script&lang=js&"
export * from "./highlightGrid.vue?vue&type=script&lang=js&"
import style0 from "./highlightGrid.vue?vue&type=style&index=0&id=071d0bc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d0bc7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VOverlay,VRow})
